export default __webpack_public_path__ + "static/media/element_17.a6dd963a.webp";